import { render, staticRenderFns } from "./leftSide.vue?vue&type=template&id=623e9423&"
import script from "./leftSide.vue?vue&type=script&lang=js&"
export * from "./leftSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports